export type TrendDirection = 'up' | 'down' | 'flat';

export type TrendInfo = {
  direction: TrendDirection;
  pctChange: number | null; // null when previous is 0 and current is also 0
  delta: number; // current - previous
};

const FLAT_THRESHOLD_PCT = 2; // changes below this magnitude are treated as flat

export const computeTrend = (current: number, previous: number): TrendInfo => {
  const delta = current - previous;
  if (previous === 0) {
    if (current === 0) return { direction: 'flat', pctChange: null, delta };

    return { direction: 'up', pctChange: null, delta };
  }
  const pctChange = ((current - previous) / previous) * 100;
  let direction: TrendDirection = 'flat';
  if (Math.abs(pctChange) >= FLAT_THRESHOLD_PCT) {
    direction = pctChange > 0 ? 'up' : 'down';
  }

  return { direction, pctChange, delta };
};

export const formatTrend = (trend: TrendInfo): string => {
  if (trend.pctChange === null) {
    if (trend.delta === 0) return '—';

    return trend.delta > 0 ? `+${trend.delta}` : `${trend.delta}`;
  }
  const sign = trend.pctChange > 0 ? '+' : '';

  return `${sign}${Math.round(trend.pctChange)}%`;
};

export const trendArrow = (direction: TrendDirection): string => {
  if (direction === 'up') return '↗';
  if (direction === 'down') return '↘';

  return '→';
};

export const trendColor = (direction: TrendDirection, isInverse = false): string => {
  // isInverse: when up means bad (e.g., rejections, errors)
  if (direction === 'flat') return 'text-gray-500';
  if (isInverse) {
    return direction === 'up' ? 'text-red-600' : 'text-green-600';
  }

  return direction === 'up' ? 'text-green-600' : 'text-amber-600';
};
